/**
 * Part 6 (2026-10-07; owner Part 6 notifications) — the notifications a customer can actually read.
 *
 * A notification's message is `renderedContent`, written by the Module 12 renderer (Batch 17, not built yet). Until a
 * notification carries one, there is nothing to show the customer, so it is neither listed nor counted as unread. No
 * content is ever invented here. Once Module 12 fills `renderedContent`, every such notification appears unchanged.
 */
export function readableNotifications(data) {
  const items = data?.items || (Array.isArray(data) ? data : []);
  return items.filter((n) => typeof n.renderedContent === "string" && n.renderedContent.trim() !== "");
}
